module.exports = __webpack_public_path__ + "img/icon-waiting_time.2b795234.svg";